import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment';
import classnames from 'classnames';

import StatusSelectDropdown from '../../DropdownMenu/LeadEngageMode';

import './index.scss';

const getStatusText = (isExpired) => {
  let dropdown = {};
  if (isExpired) {
    dropdown = {
      dropdown: { edit: false, delete: true, report: true, copy: true },
      value: 'Expired',
      showdropdown: true,
    };
  } else {
    dropdown = {
      dropdown: { edit: true, delete: true, report: true, copy: true },
      value: 'Created',
      showdropdown: true,
    };
  }
  return dropdown;
};

const Campaign = (props) => {
  const {
    timezone,
    campaign,
    openEditModel,
    openDetailsPane,
    webhookCopy,
    downloadReport,
    deleteCampaign,
    auth,
  } = props;
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);
  function useOutsideAlerter(ref) {
    /**
     * Alert if clicked on outside of element
     */

    function handleClickOutside(event) {
      if (
        (ref.current && !ref.current.contains(event.target)) ||
        (event.target && event.target.id && event.target.id !== campaign.id)
      ) {
        console.log('1');
        event.stopPropagation();
        event.preventDefault();
        setStatusDropdownVisibility(false);
        setactiveIconVisibility(false);
      } else if (event.target.id === campaign.id) {
        console.log('2');
        event.stopPropagation();
        event.preventDefault();
        setStatusDropdownVisibility(true);
        setactiveIconVisibility(true);
      }
    }
    useEffect(() => {
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
      };
    });
  }

  const [statusDropdownVisibility, setStatusDropdownVisibility] = useState(
    false,
  );
  const [activeIconVisibility, setactiveIconVisibility] = useState(false);
  const [activeCampign, setActiveCampaign] = useState(null);
  const conversationStatus = { value: 'EDIT' };
  const onClickofLink = (event, key, campaign) => {
    if (event.target.id === campaign) {
      if (activeCampign === event.target.id && statusDropdownVisibility) {
        setStatusDropdownVisibility(false);
        setactiveIconVisibility(false);
        setActiveCampaign(null);
      } else {
        setStatusDropdownVisibility(key);
        setactiveIconVisibility(key);
        setActiveCampaign(event.target.id);
      }
    }
  };
  const handleStatusChange = (status, campaign) => {
    console.log(status, campaign);
    if (status === 'edit') {
      openEditModel(campaign);
    }
    if (status === 'copy') {
      webhookCopy(campaign);
    }
    if (status === 'report') {
      downloadReport(campaign.id);
    }
    if (status === 'Delete') {
      deleteCampaign(campaign);
    }
  };

  const clickCampaign = (event, campaign) => {
    if (!statusDropdownVisibility) {
      downloadReport(campaign.id);
    }
  };
  const getStatusData = () => {
    if (getStatusText(campaign.is_expired).showdropdown) {
      return (
        <div className="data">
          <span>{getStatusText(campaign.is_expired).value}</span>{' '}
          {moment(campaign.updated_time)
            .tz(timezone)
            .format('Do MMM YYYY, hh:mm a')}
          {campaign.service_name && (
            <>
              <sapn className="data-divider"> &#183; </sapn>{' '}
              <span>{campaign.service_name}</span>
            </>
          )}
        </div>
      );
    } else {
      return (
        <div className="data">
          <span className="sending">
            {getStatusText(campaign.is_expired).value}
          </span>{' '}
          {moment(campaign.updated_time)
            .tz(timezone)
            .format('Do MMM YYYY, hh:mm a')}
        </div>
      );
    }
  };
  return (
    <div
      className="leadenage_campaign"
      style={{
        backgroundColor: !getStatusText(campaign.is_expired).showdropdown
          ? ' #F5F6F8'
          : '#FFFF',
      }}
      onClick={(event) => clickCampaign(event, campaign)}
    >
      <div className="leadenage_campaign_status_data">
        <div className="title">
          <div className="name">{campaign.name}</div>
          {campaign.is_expired && <span className="status-tag">EXPIRED</span>}
          <div
            className={classnames('menu mobile-only-dot', {
              'border-icon': activeIconVisibility,
            })}
          >
            {getStatusText(campaign.is_expired).showdropdown && (
              <a
                href="#"
                onClick={(event) => {
                  event.stopPropagation();
                  event.preventDefault();
                  onClickofLink(event, true, campaign.id);
                }}
              >
                <i id={campaign.id} className="material-icons">more_horiz</i>
              </a>
            )}
            <StatusSelectDropdown
              visibility={statusDropdownVisibility}
              position="tl"
              onVisibilityChange={(visibility) => {
                setStatusDropdownVisibility(visibility, campaign.id);
                setactiveIconVisibility(visibility);
              }}
              selectedOption={conversationStatus.value}
              className="menu__dropdown"
              onChange={(event) => {
                handleStatusChange(event, campaign);
              }}
              dropdownMenu={getStatusText(campaign.is_expired).dropdown}
            />
          </div>
        </div>
        {getStatusData()}
      </div>

      <div className="leadenage_campaign_data">
        <div className="convertion_rate">
          <div className="value">{campaign.conversion_rate}%</div>
          <div className="description">Conversion Rate</div>
        </div>
        <div className="booking_count">
          <div className="value">{campaign.bookings}</div>
          {auth.domain === 'FITNESS' ? (<div className="description">Enrollments</div>) : (<div className="description">Bookings</div>)}
        </div>
        <div
          className={classnames('menu lgdevice-only', {
            'border-icon': activeIconVisibility,
          })}
        >
          {getStatusText(campaign.is_expired).showdropdown && (
            <a
              href="#"
              onClick={(event) => {
                event.stopPropagation();
                event.preventDefault();
                onClickofLink(event, true, campaign.id);
              }}
            >
              <i id={campaign.id} className="material-icons">more_horiz</i>
            </a>
          )}
          <StatusSelectDropdown
            visibility={statusDropdownVisibility}
            position="tl"
            onVisibilityChange={(visibility) => {
              setStatusDropdownVisibility(visibility, campaign.id);
              setactiveIconVisibility(visibility);
            }}
            selectedOption={conversationStatus.value}
            className="menu__dropdown"
            onChange={(event) => {
              handleStatusChange(event, campaign);
            }}
            dropdownMenu={getStatusText(campaign.is_expired).dropdown}
          />
        </div>
      </div>
      {/* <CampaignDetails visibility={modelopen} onClose={this.closeCampaignModel} campaign={campaignSample} {...this.props}/> */}
    </div>
  );
};

export default Campaign;
